/* Duskhaven mockup refresh: scroll rails with arrows, collection filter drawer, sort, load more. */
(function () {
  if (window.__dhRefresh) return;
  window.__dhRefresh = true;

  /* ---------- Scroll rails (featured carousel, category tiles) ---------- */
  function railStep(rail) {
    var first = rail.firstElementChild;
    if (!first) return rail.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function updateRail(wrap) {
    var rail = wrap.querySelector('[data-dh-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-dh-rail-prev]');
    var next = wrap.querySelector('[data-dh-rail-next]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    var scrollable = max > 2;
    var controls = wrap.querySelector('[data-dh-rail-controls]');
    if (controls) controls.hidden = !scrollable;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  function railWrap(el) {
    return el.closest('[data-dh-rail-wrap]') || el.closest('.dh-col-cats') || el.closest('.dh-section');
  }

  function bindRails(root) {
    (root || document).querySelectorAll('[data-dh-rail]').forEach(function (rail) {
      if (rail.__dhRail) return;
      rail.__dhRail = true;
      var wrap = railWrap(rail);
      if (!wrap) return;
      var tick = false;
      rail.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () { tick = false; updateRail(wrap); });
      }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { updateRail(wrap); }).observe(rail);
      // Keep the current category tile in view.
      var current = rail.querySelector('[aria-current="page"]');
      if (current) {
        var li = current.closest('li') || current;
        rail.scrollLeft = Math.max(0, li.offsetLeft - rail.offsetLeft - 20);
      }
      updateRail(wrap);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var prev = target.closest('[data-dh-rail-prev]');
    var next = target.closest('[data-dh-rail-next]');
    if (prev || next) {
      var wrap = railWrap(prev || next);
      var rail = wrap && wrap.querySelector('[data-dh-rail]');
      if (!rail) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: (prev ? -1 : 1) * railStep(rail), behavior: reduce ? 'auto' : 'smooth' });
      return;
    }

    var open = target.closest('[data-dh-filter-open]');
    if (open) {
      var dialog = document.getElementById(open.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        document.body.classList.add('dh-lock');
      }
      return;
    }
    var close = target.closest('[data-dh-filter-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d) d.close();
      return;
    }
    if (target.matches('dialog[data-dh-filters]')) {
      var r = target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) target.close();
      return;
    }

    var more = target.closest('[data-dh-col-more]');
    if (more && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      loadMore(more);
    }
  });

  document.addEventListener('close', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('dialog[data-dh-filters]') && !document.querySelector('dialog.dh-dialog[open]')) {
      document.body.classList.remove('dh-lock');
    }
  }, true);

  /* ---------- Filters and sort ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-dh-filter-form], [data-dh-sort]')) return;
    // Drop empty price inputs so the URL stays clean.
    form.querySelectorAll('input').forEach(function (input) {
      if ((input.type === 'number' || input.type === 'hidden') && input.value === '') input.disabled = true;
    });
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select.matches && select.matches('[data-dh-sort-select]')) {
      var form = select.form;
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
  });

  /* ---------- Load more ---------- */
  function loadMore(link) {
    if (link.getAttribute('aria-busy') === 'true') return;
    var grid = document.querySelector('[data-dh-col-grid]');
    if (!grid) { window.location.href = link.href; return; }
    link.setAttribute('aria-busy', 'true');
    var label = link.textContent;
    link.textContent = 'Loading…';
    fetch(link.href, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-dh-col-grid]');
        if (!incoming) throw new Error('No products');
        var added = document.createDocumentFragment();
        var firstNew = null;
        Array.prototype.slice.call(incoming.children).forEach(function (card) {
          var node = document.importNode(card, true);
          if (!firstNew) firstNew = node;
          added.appendChild(node);
        });
        grid.appendChild(added);
        grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

        var nextLink = doc.querySelector('[data-dh-col-more]');
        var progress = doc.querySelector('[data-dh-col-progress]');
        var bar = doc.querySelector('[data-dh-col-bar]');
        var here = document.querySelector('[data-dh-col-progress]');
        var hereBar = document.querySelector('[data-dh-col-bar]');
        if (progress && here) here.textContent = progress.textContent;
        if (bar && hereBar) hereBar.style.width = bar.style.width;
        if (nextLink) {
          link.href = nextLink.getAttribute('href');
          link.textContent = label;
          link.removeAttribute('aria-busy');
        } else {
          link.remove();
        }
        if (firstNew) {
          var focusTarget = firstNew.querySelector('h3 a');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }
      })
      .catch(function () { window.location.href = link.href; });
  }

  function init(root) { bindRails(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
